<template>
    <div>
        <MainToolbar v-bind:notif="notif" v-bind:objDialog="objDialog"></MainToolbar>
        <transition name="router-anim" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutDown">
            <v-content>
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex md4 xs12 offset-md8>
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12><strong headline>Versions</strong></v-flex>
                        <v-flex v-for="agrisType in agrisTypes" :key="agrisType" xs4 md2 lg1>
                            <v-switch v-model="agrisTypesSelected" :label="`${agrisType}`" :value="agrisType" color="green"></v-switch>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12><strong headline>Agent Type</strong></v-flex>
                        <v-flex v-for="dbtype in dbtypes" :key="dbtype" xs4 md2 lg1>
                            <v-switch v-model="dbtypesSelected" :label="`${dbtype}`" :value="dbtype" color="green"></v-switch>
                        </v-flex>
                    </v-layout>
                    <v-data-table v-model="selected"
                                :headers="releaseheaders"
                                :items="availableReleases.filter(r=>dbtypesSelected.indexOf(r.AgentType)>-1 &&agrisTypesSelected.indexOf(r.AgrisVersion)>-1)"
                                :pagination.sync="pagination"
                                :search="search"
                                :rows-per-page-items=[10,20,35]
                                class="elevation-1">
                            <template slot="headers" slot-scope="props">
                            <tr>
                                <th v-for="header in props.headers"
                                :key="header.text"
                                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.visibility]"
                                @click="changeSort(header.value)">
                                <v-icon small>arrow_upward</v-icon>
                                {{ header.text }}
                                </th>
                            </tr>
                            </template>
                            <template slot="items" slot-scope="props">
                            <td class="text-xs-center hidden-xs-only">{{ props.item.AgentType }}</td>
                            <td class="text-xs-center">{{ props.item.AgentVersion }}</td>
                            <td class="text-xs-center">{{ props.item.AgrisVersion }}</td>
                            <td class="text-xs-center hidden-xs-only">{{ formatDate2(new Date(props.item.CreationTime)) }}</td>
                            <td class="text-xs-center hidden-xs-only">{{ props.item.IsDeployed }}</td>
                            <td class="justify-center layout px-0" v-show="IsApproveAccess">
                                <v-btn v-if="!props.item.IsDeployed" fab small dark color="green" class="white--text" @click="approveQARelease(props.item)">
                                    <v-icon>sync</v-icon>
                                </v-btn>
                            </td>
                            </template>
                            <template slot="no-data"> Sorry, nothing to display here. </template>
                                Your search for "{{ search }}" found no results.

                    </v-data-table>
                    <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
                </v-container>
            </v-content>
        </transition>
    </div>
</template>

<script>
import moment from 'moment';
import DataService from '@/services/data-service';

import MainToolbar from '@/components/MainToolbar.vue';

const dataService = new DataService();

export default {
  name: 'approveRelease',
  components: {
    MainToolbar,
  },
  data() {
    return {
      actioninProgress: false,
      notif: {
        color: 'success',
        message: '',
        show: false,
      },
      objDialog: {
        dialog_title: '',
        dialog_body: '',
        btn_ok_text: 'Ok',
        btn_cancel_text: 'Cancel',
        show: false,
        result: undefined,
      },
      search: '',

      selectedRelease: null,
      pagination: {
        sortBy: 'DisplayName',
      },

      agrisTypes: [],
      availableReleases: [],
      agrisTypesSelected: [],
      dbtypes: [],
      dbtypesSelected: [],
      selected: [],
      releaseheaders: [],
    };
  },
  created() {
    this.initialize();
    this.releaseheaders = [
      {
        text: 'AgentType',
        value: 'AgentType',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'AgentVersion',
        value: 'AgentVersion',
        align: 'left',
        width: '1%',
      },
      {
        text: 'AgrisVersion',
        value: 'AgrisVersion',
        align: 'left',
        width: '1%',
      },
      {
        text: 'CreationTime',
        value: 'CreationTime',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'In Production',
        value: 'IsDeployed',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
    ];
    if (this.IsApproveAccess) {
      this.releaseheaders.push({
        text: 'Actions',
        align: 'left',
        width: '1%',
        sortable: false,
      });
    }
  },
  computed: {
    IsApproveAccess() {
      return this.$store.getters.IsValidCode('AH2AR0002');
    },
  },
  methods: {
    showNotif(obj) {
      const that = this;
      that.notif.show = true;
      that.notif.message = obj.message;
      that.notif.color = obj.color;
    },
    initialize() {
      const that = this;
      that.actioninProgress = true;
      that.availableReleases = [];
      that.selectedRelease = null;
      dataService.getReleases().then((releases) => {
        const qaReleases = releases.filter(e => !e.IsProduction);// .0map(e=>e.AgentType).filter((v, i, a) => a.indexOf(v) === i)
        for (let i = 0; i < qaReleases.length; i += 1) {
          qaReleases[i].IsDeployed = releases.filter(e => e.IsProduction && e.AgentType === qaReleases[i].AgentType && e.AgrisVersion === qaReleases[i].AgrisVersion && e.AgentVersion === qaReleases[i].AgentVersion).length > 0;
        }
        console.log(qaReleases);
        that.availableReleases = qaReleases;// .filter(f=>f.AgentType==this.editedItem.AgentType && this.compareVersion(f.AgrisVersion,this.editedItem.AgrisVersion) && this.editedItem.IsLive==f.IsProduction);
        that.agrisTypes = qaReleases.map(e => e.AgrisVersion).filter((v, i, a) => a.indexOf(v) === i);
        that.agrisTypesSelected = that.agrisTypes;
        that.dbtypes = qaReleases.map(e => e.AgentType).filter((v, i, a) => a.indexOf(v) === i);
        that.dbtypesSelected = that.dbtypes;
        that.actioninProgress = false;
      });
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    formatDate2(value) {
      let formatedDate = value;
      if (formatedDate) {
        if (typeof formatedDate === 'string') {
          formatedDate = new Date(formatedDate);
        }
        const serverClientTimeZoneDiff = ((new Date().getTimezoneOffset() - (240)) / 60) * -1;
        formatedDate.setTime(formatedDate.getTime() + (serverClientTimeZoneDiff * 60 * 60 * 1000));
        return moment(String(formatedDate)).format('MMM Do YYYY');
      } return '';
    },
    approveQARelease(release) {
      this.actioninProgress = true;
      dataService.approveReleases(release).then((success) => {
        if (success) {
          this.initialize();
          this.showNotif({ color: 'success', message: 'Approved' });
        } else this.showNotif({ color: 'error', message: 'Unable to Approve' });
        this.actioninProgress = false;
      });
    },
  },
};
</script>

<style scoped>
.container {
  padding-top: 2px;
  padding-bottom: 2px;
}
.cell-font-size {
  font-size: 12px;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
</style>
